import React from 'react';
import './style.scss';

export const Badge = ({ count }) => (
  <div className="badge">{count}</div>
);



// WEBPACK FOOTER //
// ./src/view/common/Badge/index.jsx